import React from "react";
import HeaderBar, { Subtab } from "./HeaderBar";
import clsx from "clsx";

interface Props {
  preTitleContent?: string | JSX.Element;
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  titleRightElement?: JSX.Element;
  subtitleRightElement?: JSX.Element;
  subtabs?: Array<Subtab>;
  buttons?: JSX.Element;
  children: React.ReactNode;
  isMaxWidthEnabled?: boolean;
  /** Set when the title interpolates a user-chosen / customer-supplied name; masks the heading in PostHog */
  titleSensitive?: boolean;
}

const PortalPageHeaderWrapper = ({
  preTitleContent,
  title,
  subtitle,
  titleRightElement,
  subtitleRightElement,
  subtabs,
  buttons,
  children,
  isMaxWidthEnabled = false,
  titleSensitive,
}: Props) => {
  return (
    <div className={clsx("mb-8 w-full", !isMaxWidthEnabled && "mx-auto max-w-[1200px]")}>
      <HeaderBar
        preTitleContent={preTitleContent}
        title={title}
        subtitle={subtitle}
        titleRightElement={titleRightElement}
        subtitleRightElement={subtitleRightElement}
        subtabs={subtabs}
        buttons={buttons}
        titleSensitive={titleSensitive}
      />
      {children}
    </div>
  );
};

export default PortalPageHeaderWrapper;
